module.exports = __webpack_public_path__ + "static/media/3.73941b00.png";